'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './seed-list.routes';

export class ActivationCodeSeedListComponent {
  constructor(Auth, ActivationCodeService, dialogs, $uibModal, $state, $stateParams, DTOptionsBuilder) {
    'ngInject';

    this.ActivationCodeService = ActivationCodeService;
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.$state = $state;
    this.data = [];
    this.isAdmin = Auth.isAdminSync;

    this.id = $stateParams.id;

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'desc'])
      .withOption('buttons',[{
        extend: 'excel',
        title: "Activation Code Seed " + this.id
      },{
        extend: 'csv',
        title: "Activation Code Seed " + this.id
      },{
        title: "Activation Code Seed " + this.id,
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'portrait',
        pageSize: 'LETTER'
      },{
        extend: 'print',
        title: "Activation Code Seed " + this.id
      }]);


    this.loadData();
  }

  loadData() {
    this.ActivationCodeService.queryBySeed({seedId: this.id}, (data) => {
      this.data = data;
    }, err => {
      console.log("Could not retrieve activation codes by seed.")
    })
  }

  delete(code) {
    var that = this;

    var codeText = "<br/><br/><b>" + code.code + "</b> of group <em>"+ code.group +"</em><br/><p>" + code.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Activation Code?", "Do you really want to delete the activation code?" + codeText);
    dlg.result.then(() => {
      // OK delete it
      that.ActivationCodeService.delete({id: code._id},
        () => {
          that.loadData();
        },
        err => {
          alert("Could not delete activation code");
        });
    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduuApp.activationCodeSeedList', [uiRouter])
  .config(routes)
  .component('activationCodeSeedList', {
    template: require('./seed-list.html'),
    controller: ActivationCodeSeedListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/activation-code/seed/seed-list.component.js